/* eslint-disable react/prop-types */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/restrict-plus-operands */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
import { IonIcon } from '@ionic/react';
import { chevronDown, chevronForward } from 'ionicons/icons';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { ICasinoSchema, IClubTier } from 'appRedux/models/casinoModels';
import { IState } from 'appRedux/createStore';
import { getCasinoFolderName } from 'common/common';

const toTitleCase = (str: string) =>
  str.toLowerCase().replace(/\b\w/g, (c) => c.toUpperCase());

interface ProfileClubCardProps {
  casino: ICasinoSchema;
}

const ProfileClubCard: React.FC<ProfileClubCardProps> = ({ casino }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const folder = getCasinoFolderName(casino.casinoId);
  const tiers: IClubTier[] = casino.tiers ?? [];
  const playerCardInfo = useSelector((state: IState) => state.app.persistedState.playerCardInfo);

  const currentTier: IClubTier | undefined = tiers.find((t) => {
    const tierName = t.name.toLowerCase();
    const rankName = playerCardInfo?.rankingName?.toLowerCase() ?? '';
    if (!rankName) return false;
    if (tierName === rankName) return true;
    if (rankName.length > 2 && tierName.includes(rankName)) return true;
    if (rankName.length > 2 && rankName.includes(tierName)) return true;
    return false;
  });
  const nextTier = tiers.find((t) => t.id === currentTier?.nextTierId);

  if (!folder) return null;

  if (!playerCardInfo || !currentTier) {
    return (
      <div className="profile-club-card-wrap profile-club-card-wrap--no-tier">
        <div className="profile-club-card__no-tier">
          <div className="profile-club-card__no-tier-icon">!</div>
          <div className="profile-club-card__no-tier-content">
            <span className="profile-club-card__no-tier-title">No Club Tier Found</span>
            <span className="profile-club-card__no-tier-msg">
              No club tier account is linked to this player for {casino.displayName}.
            </span>
          </div>
        </div>
      </div>
    );
  }

  const clubDiagonalUrl = `url(${process.env.PUBLIC_URL}/assets/icon/club-diagonal.svg)`;

  const points = playerCardInfo.pointBalance ?? 0;
  const remainingToNextTier = Math.max(0, (currentTier.pointsToNextTier ?? 0) - points);
  const progressPct = currentTier.pointsToNextTier
    ? Math.min(100, Math.round((points / currentTier.pointsToNextTier) * 100))
    : 100;

  const hideBrokenImg = (e: React.SyntheticEvent<HTMLImageElement>) => {
    (e.target as HTMLImageElement).style.display = 'none';
  };

  const nextTierPoints = nextTier && !currentTier.nextTierInviteOnly
    ? remainingToNextTier.toLocaleString()
    : null;

  const getSsSlug = (name: string): string => {
    const lower = name.toLowerCase();
    if (lower.includes('a-list') || lower.includes('a list')) return 'a-list';
    if (lower.includes('gm')) return 'gm-club';
    if (lower.includes('platinum')) return 'platinum';
    if (lower.includes('gold')) return 'gold';
    if (lower.includes('silver')) return 'silver';
    if (lower.includes('red')) return 'red';
    return lower.replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '');
  };
  const ssSlug = folder === 'silversevens' ? getSsSlug(currentTier.name) : '';
  const hasSuperTierLayout = folder === 'silversevens' && (currentTier.nextTierInviteOnly || currentTier.isHighestTier);

  const getSsProgressGradient = (slug: string): string => {
    if (slug === 'red') return 'linear-gradient(to right, #441717, #dd1e1e)';
    if (slug === 'silver') return 'linear-gradient(to right, #727272, #bbb)';
    if (slug === 'gold') return 'linear-gradient(to right, #53401f, #f5b327)';
    if (slug === 'platinum') return 'linear-gradient(to right, #747474, #b7b7b7)';
    return 'none';
  };

  const getSsReqColors = (slug: string): { num: string; unit: string } => {
    if (slug === 'gold') return { num: '#7E5424', unit: 'rgba(66,49,30,0.698)' };
    if (slug === 'platinum') return { num: '#4A4A4A', unit: 'rgba(34,34,34,0.698)' };
    return { num: '#fff', unit: 'rgba(255,255,255,0.70)' };
  };

  const resolvedGradient = folder === 'silversevens' ? 'transparent' : currentTier.gradient;
  const resolvedProgressGradient = folder === 'silversevens'
    ? (currentTier.progressGradient ?? getSsProgressGradient(ssSlug))
    : (currentTier.progressGradient ?? 'none');

  return (
    <div className={`profile-club-card-wrap profile-club-card-wrap--${folder}`}>
      <div
        className="profile-club-card"
        style={{
          '--tier-gradient': resolvedGradient,
          '--progress-gradient': resolvedProgressGradient,
          '--title-shadow': currentTier.titleTextShadow ?? 'none',
          '--club-diagonal': clubDiagonalUrl,
          ...(folder === 'lotc' ? { '--subtitle-color': currentTier.subtitleColor ?? '#ffbf2a' } : {}),
          ...(folder === 'redwind' ? {
            '--title-gradient': currentTier.titleGradient ?? 'linear-gradient(90deg, #F23039 0%, #FE3C45 100%)',
            '--subtitle-color': currentTier.subtitleColor ?? '#9D999A',
          } : {}),
          ...(folder === 'ach' ? {
            '--text-color': currentTier.textColor ?? '#333',
            '--text-color-muted': currentTier.textColorMuted ?? 'rgba(51,51,51,0.7)',
            '--tier-name-color': currentTier.tierNameColor ?? '#fff',
          } : {}),
        } as React.CSSProperties}
      >
        {folder === 'silversevens' && (
          <div className="profile-club-card__ss-bg">
            <img
              src={`${process.env.PUBLIC_URL}/assets/images/ss-bg-${ssSlug}.png`}
              alt=""
              onError={hideBrokenImg}
            />
          </div>
        )}
        {folder === 'silversevens' && !hasSuperTierLayout && (
          <div className="profile-club-card__ss-frame">
            <img
              src={`${process.env.PUBLIC_URL}/assets/images/ss-frame-${ssSlug}.svg`}
              alt=""
              onError={hideBrokenImg}
            />
          </div>
        )}
        {folder === 'redwind' && (
          <img
            src={`${process.env.PUBLIC_URL}/assets/images/RWC_clubcard_arrow.png`}
            alt=""
            className="profile-club-card__rwc-arrow"
          />
        )}
        {folder === 'ach' && (
          <>
            <div className="profile-club-card__ach-metal">
              <img src={`${process.env.PUBLIC_URL}/assets/images/ach-metal.png`} alt="" />
            </div>
            <div className="profile-club-card__ach-wave">
              <img
                src={`${process.env.PUBLIC_URL}/assets/images/ach-wave-${currentTier.id}.svg`}
                alt=""
                className="profile-club-card__ach-wave-img"
              />
              <div className="profile-club-card__bottom">
                {currentTier.pointsToNextTier !== null && (
                  <div className="profile-club-card__progress-bar">
                    <div
                      className="profile-club-card__progress-fill"
                      style={{ width: `${progressPct}%` }}
                    />
                  </div>
                )}
                <div className="profile-club-card__next-tier">
                  {currentTier.isHighestTier ? (
                    <span className="profile-club-card__next-tier-num">Highest Tier</span>
                  ) : nextTier && (
                    nextTierPoints ? (
                      <>
                        <span className="profile-club-card__next-tier-num">{nextTierPoints}</span>
                        <span className="profile-club-card__next-tier-text">pts to</span>
                        <span className="profile-club-card__next-tier-num">{toTitleCase(nextTier.name)} Tier</span>
                      </>
                    ) : (
                      <>
                        <span className="profile-club-card__next-tier-text">Invite only to</span>
                        <span className="profile-club-card__next-tier-num">{toTitleCase(nextTier.name)}</span>
                      </>
                    )
                  )}
                </div>
              </div>
            </div>
          </>
        )}
        {folder === 'silversevens' ? (
          <div className="profile-club-card__ss-content">
            <div className="profile-club-card__ss-logo">
              <img src={`${process.env.PUBLIC_URL}/assets/images/ss-aplay-logo.png`} alt="A Play Club" />
            </div>
            {hasSuperTierLayout && (
              <div
                className="profile-club-card__ss-super-name"
                style={{
                  backgroundImage: currentTier.isHighestTier
                    ? 'linear-gradient(108.91deg, rgb(226,235,245) 10.68%, rgb(125,162,203) 30.19%, rgb(177,202,228) 63.22%)'
                    : 'linear-gradient(104.12deg, #fff 6.42%, #999 19.15%, #fff 41.67%, #999 54.45%, #fff 89.15%)',
                  ...(currentTier.isHighestTier ? { textShadow: '0px 0px 4px #1e5170' } : {}),
                }}
              >
                {currentTier.name}
              </div>
            )}
            <div className="profile-club-card__ss-stats">
              {playerCardInfo.showPointBalance && playerCardInfo.pointBalance !== null && (
                <div className="profile-club-card__ss-stat">
                  <span className="profile-club-card__ss-stat-value">{playerCardInfo.pointBalance.toLocaleString()}</span>
                  <span className="profile-club-card__ss-stat-label">points</span>
                </div>
              )}
              {playerCardInfo.showFreeplayBalance && playerCardInfo.freeplayBalance !== null && (
                <div className="profile-club-card__ss-stat">
                  <span className="profile-club-card__ss-stat-value">${playerCardInfo.freeplayBalance.toLocaleString()}</span>
                  <span className="profile-club-card__ss-stat-label">Free play</span>
                </div>
              )}
            </div>
            {!hasSuperTierLayout && (
              <div className="profile-club-card__ss-suits">
                <img
                  src={`${process.env.PUBLIC_URL}/assets/images/ss-suits-${ssSlug}.svg`}
                  alt=""
                  onError={hideBrokenImg}
                />
              </div>
            )}
            {!hasSuperTierLayout && currentTier.pointsToNextTier != null && (
              <div className="profile-club-card__progress-bar">
                <div
                  className="profile-club-card__progress-fill"
                  style={{ width: `${progressPct}%` }}
                />
              </div>
            )}
            <p className="profile-club-card__ss-next-tier">
              {currentTier.isHighestTier ? (
                <span>Highest tier</span>
              ) : currentTier.nextTierInviteOnly && nextTier ? (
                <>
                  <span className="profile-club-card__ss-next-tier-dim">Invite only to </span>
                  <span className="profile-club-card__ss-next-tier-val">{nextTier.name}</span>
                </>
              ) : nextTierPoints && nextTier ? (
                <>
                  <span className="profile-club-card__ss-next-tier-val">{nextTierPoints} </span>
                  <span className="profile-club-card__ss-next-tier-dim">pts to </span>
                  <span className="profile-club-card__ss-next-tier-val">{nextTier.name}</span>
                </>
              ) : null}
            </p>
          </div>
        ) : (
          <div className="profile-club-card__content">
            <div className="profile-club-card__header">
              <div>
                <div className="profile-club-card__tier-name">{playerCardInfo.rankingName ?? currentTier.name}</div>
                <div className="profile-club-card__subtitle">{casino.memberLabel}</div>
              </div>
              {(folder === 'lotc' || folder === 'ach' || casino.logos?.logoAlt) && (
                <img
                  src={folder === 'lotc'
                    ? `${process.env.PUBLIC_URL}/assets/images/LOTC_White.svg`
                    : folder === 'ach'
                      ? `${process.env.PUBLIC_URL}/assets/images/ach-logo-${currentTier.id}.svg`
                      : casino.logos?.logoAlt}
                  alt={casino.displayName}
                  className="profile-club-card__logo"
                  onError={hideBrokenImg}
                />
              )}
            </div>

            <div className="profile-club-card__stats">
              {playerCardInfo.showPointBalance && playerCardInfo.pointBalance !== null && (
                <div className="profile-club-card__stat">
                  <span className="profile-club-card__stat-value">
                    {playerCardInfo.pointBalance.toLocaleString()}
                  </span>
                  <span className="profile-club-card__stat-label">Points</span>
                </div>
              )}
              {playerCardInfo.showFreeplayBalance && playerCardInfo.freeplayBalance !== null && (
                <div className="profile-club-card__stat">
                  <span className="profile-club-card__stat-value">
                    ${playerCardInfo.freeplayBalance.toLocaleString()}
                  </span>
                  <span className="profile-club-card__stat-label">Free Play</span>
                </div>
              )}
            </div>

            {folder !== 'ach' && (
              <div className="profile-club-card__bottom">
                {currentTier.pointsToNextTier !== null && (
                  <div className="profile-club-card__progress-bar">
                    <div
                      className="profile-club-card__progress-fill"
                      style={{ width: `${progressPct}%` }}
                    />
                  </div>
                )}
                <div className="profile-club-card__next-tier">
                  {currentTier.isHighestTier ? (
                    <span className="profile-club-card__next-tier-num">Highest Tier</span>
                  ) : nextTier && (
                    nextTierPoints ? (
                      <>
                        <span className="profile-club-card__next-tier-num">{nextTierPoints}</span>
                        <span className="profile-club-card__next-tier-text">pts to</span>
                        <span className="profile-club-card__next-tier-num">{toTitleCase(nextTier.name)} Tier</span>
                      </>
                    ) : (
                      <>
                        <span className="profile-club-card__next-tier-text">Invite only to</span>
                        <span className="profile-club-card__next-tier-num">{toTitleCase(nextTier.name)}</span>
                      </>
                    )
                  )}
                </div>
              </div>
            )}
          </div>
        )}
      </div>

      <button
        className="profile-club-card__tiers-toggle"
        onClick={() => setIsExpanded((v) => !v)}
      >
        <span>TIERS</span>
        <IonIcon icon={isExpanded ? chevronDown : chevronForward} />
      </button>

      {isExpanded && (
        <div className="profile-club-card__tiers-section">
          <div className="profile-club-card__tiers-header">
            <span>Tier</span>
            <span>Requirement</span>
          </div>
          <div className="profile-club-card__tiers-list">
            {tiers.map((tier, i) => {
              const tierSlug = folder === 'silversevens' ? getSsSlug(tier.name) : '';
              const ssReqColors = folder === 'silversevens' ? getSsReqColors(tierSlug) : null;
              return (
                <div
                  key={tier.id}
                  className={`profile-club-card__tier-row${i === 0 ? ' profile-club-card__tier-row--active' : ''}`}
                  style={{
                    '--tier-gradient': folder === 'silversevens' ? 'transparent' : tier.gradient,
                    '--title-shadow': tier.titleTextShadow ?? 'none',
                    '--club-diagonal': clubDiagonalUrl,
                    ...(ssReqColors ? {
                      '--ss-req-num-color': ssReqColors.num,
                      '--ss-req-unit-color': ssReqColors.unit,
                    } : {}),
                    ...(folder === 'lotc' ? { '--subtitle-color': tier.subtitleColor ?? '#ffbf2a' } : {}),
                    ...(folder === 'ach' ? {
                      '--text-color': tier.textColor ?? '#333',
                      '--text-color-muted': tier.textColorMuted ?? 'rgba(51,51,51,0.7)',
                      '--tier-name-color': tier.tierNameColor ?? '#fff',
                    } : {}),
                  } as React.CSSProperties}
                >
                  {folder === 'silversevens' && (
                    <img
                      src={`${process.env.PUBLIC_URL}/assets/images/ss-bg-${tierSlug}.png`}
                      alt=""
                      className="profile-club-card__tier-row-ss-bg"
                      onError={hideBrokenImg}
                    />
                  )}
                  {folder === 'ach' && (
                    <div className="profile-club-card__ach-metal">
                      <img src={`${process.env.PUBLIC_URL}/assets/images/ach-metal.png`} alt="" />
                    </div>
                  )}
                  <div
                    className={`profile-club-card__tier-row-content${tier.lightBackground ? ' profile-club-card__tier-row-content--dark' : ''}`}
                  >
                    <div className="profile-club-card__tier-row-info">
                      <span className="profile-club-card__tier-row-name">{tier.name}</span>
                      <span className="profile-club-card__tier-row-sub">{casino.memberLabel}</span>
                    </div>
                    <span className="profile-club-card__tier-row-req">
                      {tier.pointsRequired.endsWith(' points') ? (
                        <>
                          <span className="profile-club-card__tier-row-req-num">
                            {tier.pointsRequired.slice(0, -7)}
                          </span>
                          <span className="profile-club-card__tier-row-req-unit">points</span>
                        </>
                      ) : (
                        <span className="profile-club-card__tier-row-req-unit">{tier.pointsRequired}</span>
                      )}
                    </span>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};

export default ProfileClubCard;
